interface ServicesSectionProps {
  servicesAndProducts: string | null;
  className?: string;
}

export const ServicesSection = ({
  servicesAndProducts,
  className = '',
}: ServicesSectionProps) => {
  const hasContent = servicesAndProducts && servicesAndProducts.trim() !== '';

  return (
    <section className={`flex flex-col items-flex-start p-4 gap-2 bg-white shadow-[0px_1px_3px_rgba(0,0,0,0.1),0px_1px_2px_rgba(0,0,0,0.06)] rounded-lg min-h-[224px] ${className}`}>
      {/* Section Header */}
      <h2 className="w-full font-['Inter'] font-medium text-sm leading-5 text-[#0F172B]">
        Products & Services
      </h2>

      {/* Content or Empty State */}
      {hasContent ? (
        <p className="w-full font-['Inter'] font-normal text-sm leading-5 text-[#314158]">
          {servicesAndProducts}
        </p>
      ) : (
        <div className="flex flex-col items-center justify-center flex-1 text-center">
          <p className="font-['Inter'] font-normal text-sm text-[#62748E]">
          No details available
          </p>
        </div>
      )}
    </section>
  );
};
